import { createContext, useContext, useEffect } from 'react';

export type SectionStatus = 'ok' | 'warn' | 'none';

export type SectionStatusApi = {
  statuses: Record<string, SectionStatus>;
  report: (id: string, status: SectionStatus) => void;
  clear: (id: string) => void;
};

/** Defaults to an inert api so a section rendered outside the provider (tests,
 *  the dev kit) still works and simply reports nowhere. */
export const SectionStatusCtx = createContext<SectionStatusApi>({ statuses: {}, report: () => {}, clear: () => {} });

export function useAllSectionStatus(): Record<string, SectionStatus> {
  return useContext(SectionStatusCtx).statuses;
}

export function useSectionStatus(id: string): SectionStatus {
  return useContext(SectionStatusCtx).statuses[id] ?? 'none';
}

/** A section publishes what it already knows; only the spine reads it. */
export function useReportSectionStatus(id: string, status: SectionStatus): void {
  const { report, clear } = useContext(SectionStatusCtx);
  useEffect(() => {
    report(id, status);
    return () => clear(id);
  }, [id, status, report, clear]);
}
